import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Avatar from '@mui/material/Avatar';
import ProfileImage from '../components/ProfileImage';
import { chatType } from '../ChatController';
import IconToolTip from '../../../common/IconToolTip';
import OverflowTip from '../../../common/OverflowTip';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { TicketAction } from '../../Ticket/TicketColumns/Actions';
import { getWhatsappOr, updateWhatsappNumber } from '../../../actions/whatsapp';
import Loader from '../../../common/Loader';
import { useDispatch } from 'react-redux';
import { openCustomModal } from '../../../actions/modal';
import WhatsappLinkQrPopup from '../../Modals/WhatsappLinkQrPopup';
import { validateStringValue } from '../../../utils/common';
import SitePopup from '../../../common/Popups/SitePop';
import { TicketSearch } from '../../SupportTrack/RenderTicketCard';
import { isMobileView } from '../../../utils/utils';
import { trackSupportTicket } from '../../../router/roleWisePageRoute';
import { StartorJoinCall } from '../../videomeet/components/StartorJoinCall';
import WhatsappChatList from '../Modals/WhatsappChatList';
import { AttributeKeys, getNextExecutionDate, getTicketOwner, RegionsType, TicketStatus, ticketStatusList } from '../../Ticket/TicketController';
import { copyToClipboard } from '../../../actions/utils';
import { getSingleConvoIdFromUserIds } from '../../../utils/utils';
import { sendDataThroughWebsocket } from '../../../actions/websocket';
import { websocketEvents } from '../../../utils/websocket';
import { generateRoomLink } from '../../videomeet/components/constants';
import { clearConnectLink, connectRoom, enableRoom, getUserCallStatusAction } from '../../../actions/users';
import moment from 'moment';
import { isCustomerGroup } from '../../../utils/role';
import { ConnectMember } from './ConnectMember';

export const openTicketSidebar = ({ isOpenExecuteSidebar, navigate }) => {
    let searchParams = new URLSearchParams(window.location.search);
    if (isOpenExecuteSidebar) searchParams.set('isOpenExecuteSidebar', isOpenExecuteSidebar);
    else searchParams.delete('isOpenExecuteSidebar');
    searchParams = searchParams.toString();
    navigate({
        pathname: window.location.pathname,
        search: searchParams,
    });
};

const ChatHeaderMsgLoader = () => {
    const skelton = <Skeleton sx={{ background: 'rgb(237, 235, 235)', borderRadius: '1rem' }} variant='rectangular' width={'full'} height={20} animation='wave' />;
    return (
        <>
            <div className='mr-4'>
                <Skeleton variant='circular'>
                    <Avatar sx={{ height: '3rem', width: '3rem' }} />
                </Skeleton>
            </div>
            <div className='w-2/5'>{skelton}</div>
            <div className='w-16 ml-auto'>{skelton}</div>
        </>
    );
};

export default function Header(props) {
    let { loading, isSingleChat, icons, showProfileImg = true, isTicketchat, chat_id, mainChatContanerRef, handleCloseChat = () => { }, isChatPopup, openedConversation, handleChatArrowClick, isChatMinimized, unReadMessageId, chatGptQueryParams, memoizedChatDetails, memoizedMessages, isSupportTicket } = props;
    const isConnectLoading = useSelector((state) => state.loading.isConnectLoading)
    const supportTrackServiceRequest = useSelector((state) => state.serviceRequest.supportTrackServiceRequest);
    const serviceRequestData = useSelector((state) => state.serviceRequest.serviceRequestData);
    const serviceRequestList = useSelector((state) => state.serviceRequest.serviceRequestList);

    const memoizedTicketDetails = useMemo(() => {
        let t = undefined;
        if (memoizedChatDetails.type === chatType.TICKET) {
            t = serviceRequestData && serviceRequestData[chat_id];
        }
        if (isSupportTicket && supportTrackServiceRequest) {
            t = supportTrackServiceRequest;
        }
        if (!t && serviceRequestList?.data) {
            let find = serviceRequestList?.data?.find((sr) => sr.id === chat_id);
            t = find;
        }
        if (t?.location?.external_id && !isChatPopup) {
            document.title = t.location.external_id;
        }
        return t;
    }, [chat_id, serviceRequestData, memoizedChatDetails, isSupportTicket, supportTrackServiceRequest, serviceRequestList?.data, isChatPopup]);

    let data = {}

    let fe = memoizedTicketDetails && memoizedTicketDetails?.agents?.find((agent) => agent?.role === 'FE');
    const executionDate = getNextExecutionDate(memoizedTicketDetails);
    let findIssueCategory = '';
    let region_tier = '';
    if (memoizedTicketDetails && memoizedTicketDetails?.attributes?.length > 0) {
        findIssueCategory = memoizedTicketDetails?.attributes?.find((attribute) => attribute?.key === AttributeKeys.issue_category)?.value?.str;
    }
    if (memoizedTicketDetails && memoizedTicketDetails?.location?.regions?.length > 0) {
        region_tier = memoizedTicketDetails?.location?.regions?.find((region) => region?.region_key?.toLowerCase() === RegionsType.CITY.toLowerCase())?.region_tier;
    }

    if (memoizedTicketDetails && !fe) {
        data = {
            siteId: memoizedTicketDetails?.location?.external_id,
            ticketNumber: memoizedTicketDetails?.ticket_number,
            workToDo: memoizedTicketDetails?.description || '',
            address: `${memoizedTicketDetails?.location?.address || ''} ${region_tier ? `, ${region_tier}` : ''}` || '',
            executionDate: executionDate?.date ? moment(executionDate?.date).format('DD-MM-YYYY') : '',
            ...(findIssueCategory ? { issueCategory: findIssueCategory } : {}),
            clickForMoreDetails: `${memoizedTicketDetails?.cloud_website_url || window.location.origin}/support/track?ticketId=${memoizedTicketDetails?.id}`,
        }
    } else if (memoizedTicketDetails) {
        data = {
            siteId: memoizedTicketDetails?.location?.external_id || '',
            ticketNumber: memoizedTicketDetails?.ticket_number,
            engineerName: fe?.agent?.display_name || '',
            engineerMobile: fe?.agent?.phone_number || '',
            executionDate: executionDate?.date ? moment(executionDate?.date).format('DD-MM-YYYY') : '',
            status: memoizedTicketDetails?.status,
            endUser: memoizedTicketDetails?.end_user?.name || '',
            address: `${memoizedTicketDetails?.location?.address || ''} ${region_tier ? `, ${region_tier}` : ''}` || '',
            ...(findIssueCategory ? { issueCategory: findIssueCategory } : {}),
            clickForMoreDetails: `${memoizedTicketDetails?.cloud_website_url || window.location.origin}/support/track?ticketId=${memoizedTicketDetails?.id}`
        }
    }

    function jsonToReadableString(json) {
        let result = '';

        for (let key in json) {
            const humanKey = key
                .replace(/([A-Z])/g, ' $1')       // space before capital letters
                .replace(/[_-]/g, ' ')            // replace _ or - with space
                .toLowerCase()
                .replace(/^\w/, c => c.toUpperCase()); // capitalize first letter

            result += `${humanKey}: ${json[key]}\n`;
        }

        return result.trim();
    }
    const { isViewTicketByIdLoading } = useSelector((state) => state.loading);
    const { isEnableVCUserLoading } = useSelector((state) => state.loading);
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const { loggedUser } = useSelector((state) => state.auth);
    const secondUser = openedConversation?.conversants?.find?.((user) => user.userId !== loggedUser.id);

    if (loading) return <ChatHeaderMsgLoader />;
    const backToChatList = () => {
        if (isMobileView && mainChatContanerRef && mainChatContanerRef.current) {
            mainChatContanerRef.current.classList.add('mobileChatListView')
            mainChatContanerRef.current.classList.remove('mobileChatMessageView')
        }
    }


    const viewUserDetail = () => {
        if (isMobileView && mainChatContanerRef && mainChatContanerRef.current) {
            mainChatContanerRef.current.classList.add('mobileUserDetailView')
            mainChatContanerRef.current.classList.remove('mobileChatMessageView')
        }

    };
    const isSupportTrackPath = pathname === trackSupportTicket.path;

    const singleConversationId = getSingleConvoIdFromUserIds(loggedUser?.id, secondUser?.userId);

    const handleOnSuccess = async ({ room_id, conversationId }) => {
        dispatch(getUserCallStatusAction({ userId: loggedUser?.id, status: [1, 2, 3, 4] }));
        dispatch(sendDataThroughWebsocket({ action: websocketEvents.chat.videoMeetInvite, data: { userIds: [secondUser?.userId], videoMeetDetails: { videoMeetLink: generateRoomLink(room_id, conversationId), room_id: room_id } } }));
        window.open(generateRoomLink(room_id, conversationId), "_blank");
    }

    const handleEnableRoom = (event) => {
        event.stopPropagation()
        dispatch(
            openCustomModal({
                heading: 'Select Members',
                modalWidth: '40rem',
                modalHeight: 'auto',
                modalComponent: <ConnectMember members={openedConversation?.members} chat_id={chat_id} />
            })
        );

        // if (isSingleChat) {
        //     dispatch(connectRoom({
        //         "type": "SINGLE",
        //         "chat_id": chat_id,
        //         "invite": openedConversation?.members.map((ele) => ele?.id)
        //     }))
        // } else if (isTicketchat) {
        //     dispatch(openCustomModal({
        //         heading: 'Select Members',
        //         modalWidth: '30rem',
        //         modalHeight: 'auto',
        //         modalComponent: <ConnectMember members={openedConversation?.members} chat_id={chat_id} />
        //     }))
        // }
        // else {
        //     dispatch(
        //         openCustomModal({
        //             heading: 'Select Members',
        //             modalWidth: '30rem',
        //             modalHeight: 'auto',
        //             modalComponent: <ConnectMember members={openedConversation?.members} chat_id={chat_id} />
        //         })
        //     );
        // }
    }

    return (
        <div className='flex w-full items-center bg-slate-200  ' >
            {isMobileView && !isSupportTrackPath &&
                <span onClick={() => backToChatList()} className='material-icons font-bold '>chevron_left</span>
            }
            {showProfileImg ? (
                <div className='flex '>
                    <div onClick={() => viewUserDetail()} className={`mr-1 inline-block object-cover ${isChatPopup ? 'h-7 w-7 mb-4 ' : 'h-10 w-12'} text-center leading-10`}>

                        {chatGptQueryParams ?
                            <img className='h-10' src={process.env.PUBLIC_URL + '/img/sia_logo.png'} alt='' />
                            : <ProfileImage
                                imgUrl={memoizedChatDetails.icon}
                                className={`inline-block object-cover  ${isChatPopup ? 'h-7 w-7' : 'h-10 w-12'} rounded-full text-center leading-10`}
                                type={isSingleChat ? 'single' : 'group'}
                            />}
                    </div>

                </div>

            ) : (
                <></>
            )}
            <div className={`   md:w-[69%] w-[50%] ${isChatPopup ? 'text-font12 ' : 'text-font18 '} font-small `}>
                <div className='max-w-full flex items-center gap-x-2 '>
                    <div className='truncate'>
                        <OverflowTip someLongText={memoizedChatDetails.title ? memoizedChatDetails.title.replace(/\s*\[BLANK\]\s*/, '') : ''} />
                    </div>
                    {!isChatPopup && (isViewTicketByIdLoading ? (
                        <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={120} height={15} animation='wave' />
                    ) : (
                        <SiteDetails chat_id={chat_id} isChatPopup={isChatPopup} />
                    ))}
                    {(isTicketchat && memoizedTicketDetails) ? (
                        <IconToolTip title={'Ticket Details'}>
                            <span
                                className={`material-icons text-scogobgsky hover:text-scogoorange  ${isChatPopup ? 'text-font12' : 'text-font16'} cursor-pointer`}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    dispatch(copyToClipboard({ data: jsonToReadableString(data) }))
                                }}
                            >
                                content_copy
                            </span>
                        </IconToolTip>

                    ) : null}


                    {openedConversation?.members?.length > 0 ? (
                        <>
                            {
                                isConnectLoading ?
                                    <Loader size='15' />
                                    :
                                    <IconToolTip title={'Start Scogo Connect'} onClick={handleEnableRoom}>
                                        <div className="flex items-center w-7 h-7">
                                            <img src={process.env.PUBLIC_URL + '/img/scogo-connect-blue.svg'} alt="" className="w-full h-full object-contain hover:cursor-pointer" />
                                        </div>
                                    </IconToolTip>
                            }
                        </>
                    ) : null}
                </div>
            </div>

            {<div className='w-[30%] flex gap-2 items-center justify-end'>
                {!isChatMinimized && <div className='flex items-center gap-2'>
                    <div className={` flex items-center ml-auto cursor-pointer gap-5 `}>{icons()}</div>
                    {isTicketchat ? <TicketActionIcon isChatPopup={isChatPopup} memoizedTicket={memoizedTicketDetails} /> : <></>}
                </div>}
            </div>}
            {isChatPopup &&
                <div className='flex items-center'>
                    <IconToolTip title={'Close Chat'}>
                        <>
                            <span className="material-icons cursor-pointer  rounded-full hover:bg-slate-200 " onClick={(event) => {
                                event.stopPropagation();
                                handleChatArrowClick();
                            }}>

                                remove
                            </span>
                        </>

                    </IconToolTip>

                    <span onClick={(event) => {
                        event.stopPropagation();
                        handleCloseChat(chat_id);
                    }} className="material-icons cursor-pointer text-right hover:text-scogoorange text-font15 chat-popup-close-button">
                        clear
                    </span></div>}
        </div>
    );
};

const TicketActionIcon = ({ memoizedTicket, isChatPopup }) => {
    return <TicketAction ticket={memoizedTicket} tab={'ticketChat'} isChatPopup={isChatPopup} />;
};


export const WhatsappIconForChat = ({ whatsappChatListModal, title = "Forward ticket details to whatsapp", isChatPopup }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { whatsappLinkDetails } = useSelector((state) => state.whatsapp)
    const { loggedUser } = useSelector((state) => state.auth)
    const { formButtonLoading } = useSelector((state) => state.loading);
    const formName = "WhatsappQR_number_loading"

    return (
        <>
            {
                formButtonLoading[formName] ?
                    <div className='mr-3' >
                        <Loader color='#F48A21' size='15' speed='2' thickness='3' marginTop='' />
                    </div> :
                    whatsappLinkDetails?.status === 1 ?
                        <IconToolTip title={title}>
                            <span
                                className={'text-font18 mr-2 cursor-pointer'}
                                onClick={() => whatsappChatListModal()}
                            >
                                <img src={process.env.PUBLIC_URL + "/img/whatsapp.png"} alt="" className={`${isChatPopup ? 'w-6' : 'w-8'}`} />
                            </span>
                        </IconToolTip>
                        :
                        <IconToolTip title={`Link your whatsapp`}>
                            <span
                                className='text-font18  hover:text-scogoorange mr-2 cursor-pointer'
                                onClick={() => {
                                    if (loggedUser?.is_mobile_linked_with_whatsapp === 0) {
                                        let payload = {
                                            userId: loggedUser?.id,
                                            mobileNumber: loggedUser.mobile,
                                            verifyType: "PRIMARY",
                                            navigate,
                                            formName,
                                            openModal: true
                                        };
                                        dispatch(updateWhatsappNumber(payload));
                                    } else {
                                        dispatch(
                                            openCustomModal({
                                                heading: `Connect Your WhatsApp`,
                                                modalWidth: '32vw',
                                                modalHeight: 'auto',
                                                modalComponent: <WhatsappLinkQrPopup />,
                                                headerComponent: <div className='flex items-center gap-2' >

                                                    <IconToolTip title="Refresh" onClick={() => {
                                                        dispatch(getWhatsappOr({ openModal: true }))
                                                    }}>
                                                        <span className='material-icons text-scogoprimary font-medium align-middle text-4xl hover:text-scogoorange cursor-pointer'  >
                                                            refresh
                                                        </span>
                                                    </IconToolTip>
                                                </div>,
                                            })
                                        );
                                    }
                                }}
                            >
                                <img src={process.env.PUBLIC_URL + "/img/whatsapp.png"} alt="" className='w-8' style={{ filter: "saturate(0%)" }} />
                            </span>
                        </IconToolTip>
            }
        </>

    );
};

const SiteDetails = ({ chat_id, isChatPopup }) => {
    const { viewTicket } = useSelector((state) => state.tickets);
    const { conversationDetails } = useSelector((state) => state.conversations)
    const openedConversation = conversationDetails?.[chat_id];
    const address = `${validateStringValue(viewTicket?.job_site_address_1)} ${validateStringValue(viewTicket?.job_city?.city_name)} , ${validateStringValue(
        viewTicket?.job_state?.state_name
    )} `;

    if ((viewTicket?.external_site_id?.length > 0 || viewTicket?.site_branch_name?.length > 0) && openedConversation?.type === chatType.ticket) {
        return (
            <p className='max-w-[45%] truncate' >
                {address?.length > 2 ? (
                    <SitePopup siteInfo={address}>
                        <OverflowTip someLongText={`(${viewTicket?.external_site_id || viewTicket?.site_branch_name})`} textClass="text-font11 text-scogogray hover:text-scogoorange cursor-pointer " />

                    </SitePopup>
                ) : (
                    <OverflowTip someLongText={`(${viewTicket?.external_site_id || viewTicket?.site_branch_name})`} textClass="text-font11 text-scogogray " />
                )}
            </p>
        );
    }
    return <></>;
};